import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import { WohaCommonContent } from "../../../../modules/content/components/WohaCommonContent/WohaCommonContent";
import { WohaMedia } from "../../../../modules/content/components/WohaMedia/WohaMedia";
import { WohaRichText } from "../../../../modules/content/components/WohaRichText/WohaRichText";
import { WohaSection } from "../../../../modules/content/components/WohaSection/WohaSection";
import type { IFeaturedTestimonialBlockProps } from "./FeaturedTestimonialBlock.props";
export const FeaturedTestimonialBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
  testimonial,
}: IFeaturedTestimonialBlockProps) => {
  if (!eyebrow && !heading && !description && !testimonial?.quote) return null;
  const Link = getComponent("Link");
  return (
    <WohaSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-8">
        <WohaCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        {testimonial ? (
          <figure className="grid overflow-hidden rounded-2xl bg-charcoal md:grid-cols-[minmax(18rem,0.85fr)_1.15fr]">
            {testimonial.portrait ? (
              <WohaMedia
                aspectRatio="1:1"
                className="h-full rounded-none"
                media={testimonial.portrait.image}
                sizes="(min-width: 768px) 35vw, 100vw"
              />
            ) : null}
            <div
              className={cn(
                "flex flex-col justify-center p-7 md:p-12 lg:p-16",
                !testimonial.portrait && "md:col-span-full",
              )}
            >
              <blockquote>
                <WohaRichText
                  className="font-satoshi text-3xl font-medium leading-[1.2] text-white text-balance md:text-4xl"
                  content={testimonial.quote}
                />
              </blockquote>
              <figcaption className="mt-6">
                <p className="font-medium text-white">{testimonial.name}</p>
                {testimonial.attribution ? (
                  <p className="mt-1 text-sm text-white/60">{testimonial.attribution}</p>
                ) : null}
              </figcaption>
              {testimonial.link ? (
                <Link
                  aria-label={testimonial.link.accessibilityLabel || undefined}
                  className="mt-6 inline-flex min-h-11 items-center self-start text-sm font-medium text-white underline decoration-white/30 underline-offset-4 hover:decoration-white focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white"
                  href={testimonial.link.href}
                  rel={testimonial.link.openInNewTab ? "noopener noreferrer" : undefined}
                  target={testimonial.link.openInNewTab ? "_blank" : undefined}
                >
                  {testimonial.link.label}
                </Link>
              ) : null}
            </div>
          </figure>
        ) : null}
      </div>
    </WohaSection>
  );
};
FeaturedTestimonialBlock.displayName = "Block::FeaturedTestimonialBlock";
